import { defineStore } from "pinia";

export const useCurrencyStore = defineStore("currency", {
  persist: true,
  state: () => ({
    selectedCurrency: "",
    currencySymbols: {},
    currencyRates: {},
    currencyBase: "USD",
    hotelOfferCurrency: "",
  }),
  actions: {},
});
